import { useDispatch, useSelector } from "react-redux";
import {
  addLaw,
  deleteCategory,
  getLaws,
  setState,
  updateLaw,
} from "./redux/lawCollegeSlice";
import { useEffect } from "react";

export default function CRUDCategories() {
  const {
    selectedCategory,
    option,
    newCategory,
    newCategoryDescriptn,
    updatedCategory,
    categories,
  } = useSelector((state) => state.lawCollegeQuiz);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLaws());
    dispatch(
      setState({
        key: "selectedCategory",
        value: "",
      })
    );
  }, [dispatch]);

  function handleChange(key, value) {
    dispatch(
      setState({
        key,
        value,
      })
    );
  }

  const handleSubmit = async () => {
    const userId =
      JSON.parse(localStorage.getItem("user"))?.user_id ||
      JSON.parse(localStorage.getItem("user"))?.id;
    try {
      if (option === "add") {
        const exists = categories.some(
          (item) =>
            item.name.trim().toLowerCase() === newCategory.trim().toLowerCase()
        );

        if (exists) {
          alert("Category name already exists!");
          handleChange("newCategory", "");
          handleChange("newCategoryDescriptn", "");
          return;
        } else {
          const res = await dispatch(
            addLaw({
              name: newCategory,
              description: newCategoryDescriptn,
              created_by: userId,
            })
          );
          if (res) {
            handleChange("option", "");
            await dispatch(getLaws());
          }
        }
      }
      if (option === "update") {
        const res = await dispatch(
          updateLaw({
            id: Number(selectedCategory),
            name: newCategory,
            description: newCategoryDescriptn,
            updated_by: userId,
          })
        );
        if (res) {
          handleChange("option", "");
          await dispatch(getLaws());
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleDelete = async () => {
    try {
      if (window.confirm("Are you sure you want to delete the selected law?")) {
        const res = await dispatch(deleteCategory({ id: selectedCategory }));

        if (res.meta.requestStatus === "fulfilled") {
          handleChange("option", "");
          await dispatch(getLaws());
          dispatch(
            setState({
              key: "selectedCategory",
              value: "",
            })
          );
        } else {
          console.error("Delete failed:", res.error?.message);
        }
      }
    } catch (err) {
      console.error("Error deleting category:", err);
    }
  };
  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Laws for the Practice Quiz
          </h3>

          <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
            {/* Full-width Question input */}

            <div className="row mb-3">
              <label className="col-sm-3 col-form-label font-medium text-gray-700">
                Laws
              </label>
              <div className="col-sm-9" style={{ display: "flex" }}>
                <select
                  onChange={(e) => {
                    dispatch(
                      setState({
                        key: "selectedCategory",
                        value: e.target.value,
                      })
                    );
                  }}
                  value={selectedCategory}
                  className="form-select"
                >
                  <option value="">--Select a Law--</option>
                  {categories
                    ?.slice() // make a shallow copy to avoid mutating original array
                    .sort((a, b) => a.name.localeCompare(b.name)) // alphabetical sort
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.name}
                      </option>
                    ))}
                </select>
                <button
                  className="btn btn-primary px-4 py-2 rounded"
                  disabled={option === "add"}
                  onClick={() => {
                    handleChange("option", "add");
                    handleChange("newCategory", "");
                    handleChange("newCategoryDescriptn", "");
                  }}
                >
                  Add
                </button>
                {selectedCategory && (
                  <>
                    <button
                      className="btn btn-primary px-4 py-2 rounded"
                      onClick={() => {
                        handleChange("option", "update");
                        handleChange(
                          "newCategory",
                          categories.find(
                            (e) => e.id === Number(selectedCategory)
                          )?.name
                        );
                        handleChange(
                          "newCategoryDescriptn",
                          categories.find(
                            (e) => e.id === Number(selectedCategory)
                          )?.description
                        );
                      }}
                    >
                      Update
                    </button>
                    <button
                      className="btn btn-danger px-4 py-2 rounded"
                      onClick={handleDelete}
                    >
                      Delete
                    </button>
                  </>
                )}
              </div>
              {/* Buttons show only when a category is selected */}
            </div>
          </div>
          <hr className="my-8 border-gray-300" />
          {option !== "" && (
            <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
              <img
                width="30"
                height="30"
                src="https://img.icons8.com/ios/50/delete-sign--v1.png"
                alt="delete-sign--v1"
                style={{ cursor: "pointer", float: "right" }}
                onClick={() => handleChange("option", "")}
              />
              <p
                // className="col-sm-3 col-form-label font-medium text-gray-700"
                style={{ textAlign: "center" }}
              >
                <strong>
                  {" "}
                  {option === "add" ? "Create New Law " : "Update Law "}
                </strong>
              </p>{" "}
              <div className="col-sm-9" style={{ display: "flex" }}>
                <label className="col-sm-3 col-form-label font-medium text-gray-700">
                  Law Name
                </label>
                <input
                  type="text"
                  style={{ width: "50%" }}
                  className="form-control"
                  value={newCategory}
                  onChange={(e) => handleChange("newCategory", e.target.value)}
                />
              </div>
              <div
                className="col-sm-9"
                style={{ display: "flex", marginTop: "2%" }}
              >
                <label className="col-sm-3 col-form-label font-medium text-gray-700">
                  Law Description
                </label>
                <textarea
                  style={{ width: "50%" }}
                  // type="text"
                  className="form-control"
                  value={newCategoryDescriptn}
                  onChange={(e) =>
                    handleChange("newCategoryDescriptn", e.target.value)
                  }
                />
              </div>
              <button
                className="btn btn-success px-4 py-2 rounded"
                disabled={!newCategory || !newCategoryDescriptn}
                onClick={handleSubmit}
              >
                {/* Submit */}
                {option === "add" ? "Submit" : "Update"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
